enum TypeDevis {
  ACHAT = 'ACHAT',
  VENTE = 'VENTE',
}

export default TypeDevis
